package ld;

/**
 *  Events
 */
typedef LDEventEffect = {
	var attribute:String;
	var change:Int;

}

typedef LDEventDialogue = {
	var text:String;
}

typedef LDEventRequirements = {
	var attribute:String;
	var operator:String;
	var value:Int;
}

typedef LDEvent = {
  var name:String;
  var group:String;
  var subgroup:String;
  var unique:Bool;
  var image:String;
  var effects:Array<LDEventEffect>;
  var dialogue:Array<LDEventDialogue>;
  var requirements:Array<LDEventRequirements>;
}



/**
 *  Days
 */

typedef LDDayEvents = {
	var name:String;
	var group:String;
}

typedef LDDay = {
	var name:String;
	var events:Array<LDDayEvents>;
}

/**
 *  Stat names
 */

typedef LDLocalizedStat = {
	var name:String;
	var id:String;
	var positive:Bool;
}


/**
 *  Container
 */
typedef LDGameInfoFile = {
	var events:Array<LDEvent>;
	var days:Array<LDDay>;
	var localizedStats:Array<LDLocalizedStat>;
}



// Make the haxe compiler shut the fuck up.
class Types
{
	/**
	 *  Default schema
	 */
	public static var defaultSchema = '
	{  
	"events":[  
	   {  
		  "name":"Meeting hair",
		  "group":"meeting",
		  "subgroup":"meeting",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"stress",
				"change":"-1"
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"The section head is giving a long winded speech."
			 },
			 {  
				"text":"The rythmic bouncing of his toupe is soothing."
			 }
		  ],
		  "requirements":[  
			{  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 },
			 {  
				"attribute":"laziness",
				"value":7,
				"operator":"<"
			 }
		  ],
		  "image":"bg_work,expr_relax"
	   },
	   {  
		"name":"meeting deadline",
		"group":"meeting",
		"subgroup":"meeting",
		"image":"bg_work,expr_cry",
		"dialogue":[  
		   {  
			  "text":"Another meeting about deadlines."
		   },
		   {  
			  "text":"Specifically, yours."
		   }
		],
		"effects":[  
		   {  
			  "attribute":"stress",
			  "change":"2"
		   }
		],
		"requirements":[  
			{  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 }
		]
	 },
	 {  
		"name":"meeting deadline",
		"group":"meeting",
		"subgroup":"meeting",
		"image":"bg_work,expr_angry",
		"dialogue":[  
		   {  
			  "text":"A meeting on why your project is behind."
		   },
		   {  
			  "text":"You yell at your boss for setting an impossible schedule."
		   }
		],
		"effects":[  
		   {  
			  "attribute":"stress",
			  "change":"3"
		   }
		],
		"requirements":[  
			{  
				"attribute":"stress",
				"value":10,
				"operator":">="
			 }
		]
	 },
	 {  
		"name":"meeting normal",
		"group":"meeting",
		"subgroup":"meeting",
		"image":"bg_work,expr_sigh",
		"dialogue":[  
		   {  
			  "text":"Another status meeting."
		   },
		   {  
			  "text":"As usual, nothing has really changed from the last one."
		   }
		],
		"effects":[  
		],
		"requirements":[  
			{  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 },
			 {  
				"attribute":"laziness",
				"value":6,
				"operator":"<"
			 }	
		]
	 },
	   {  
		"name":"Meeting skip",
		"group":"meeting",
		"subgroup":"skip",
		"unique":false,
		"effects":[  
		   {  
			  "attribute":"stress",
			  "change":"-2"
		   },
		   {  
			"attribute":"laziness",
			"change":"1"
		 	}
		],
		"dialogue":[  
		   {  
			  "text":"You skip the meeting and browse the internet for a bit."
		   },
		   {  
			  "text":"It doesn\'t look like anyone noticed."
		   }
		],
		"requirements":[  
			
		],
		"image":"bg_work,expr_relax"
	 },
	 {  
		"name":"Meeting skip",
		"group":"meeting",
		"subgroup":"skip",
		"unique":false,
		"effects":[  
		   {  
			  "attribute":"stress",
			  "change":"-2"
		   },
		   {  
			"attribute":"laziness",
			"change":"1"
		 	}
		],
		"dialogue":[  
		   {  
			  "text":"You decide to blow off the routine status meeting and take a break"
		   },
		   {  
			  "text":"You enjoy a nice cup of coffee and look at cute animal pictures"
		   }
		],
		"requirements":[  

		],
		"image":"bg_work,expr_relax"
	 },
	 {  
		"name":"Meeting skip",
		"group":"meeting",
		"subgroup":"meeting",
		"unique":false,
		"effects":[  
		   {  
			  "attribute":"stress",
			  "change":"-2"
		   },
		   {  
			"attribute":"laziness",
			"change":"1"
		 	}
		],
		"dialogue":[  
		   {  
			  "text":"You planned on going to the meeting, but ditched at the last minute."
		   },
		   {  
			  "text":"You browse nicon*co instead."
		   }
		],
		"requirements":[  
			{  
				"attribute":"laziness",
				"value":4,
				"operator":">"
			 }	
		],
		"image":"bg_work,expr_relax"
	 },
	   {  
		  "name":"Work",
		  "group":"work",
		  "subgroup":"work",
		  "unique":true,
		  "effects":[  
			{  
				"attribute":"stress",
				"change":"1"
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You work quietly."
			 },
			 {  
				"text":"Someone dropped her coffee mug. Poor girl."
			 }
		  ],
		  "requirements":[  
			{  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 }
		  ],
		  "image":"bg_work,expr_normal"
	   },
	   {  
		"name":"Work",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
		  {  
			  "attribute":"stress",
			  "change":"2"
		   }
		],
		"dialogue":[  
		   {  
			  "text":"You work quietly."
		   },
		   {  
			  "text":"It\'s hard to tune out the lady across the hall."
		   },
		   {  
			  "text":"She can\'t seem to get off the phone with her client."
		   }
		],
		"requirements":[  
			{  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 }
		],
		"image":"bg_work,expr_normal"
	 },
	 {  
		"name":"Work",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
		  {  
			  "attribute":"stress",
			  "change":"1"
		   }
		],
		"dialogue":[  
		   {  
			  "text":"You work quietly."
		   },
		   {  
			  "text":"Someone dropped her coffee mug. Poor girl."
		   }
		],
		"requirements":[  
		  {  
			  "attribute":"stress",
			  "value":10,
			  "operator":"<"
		   }
		],
		"image":"bg_work,expr_normal"
	 },
	 {  
	  "name":"Work",
	  "group":"work",
	  "subgroup":"work",
	  "unique":true,
	  "effects":[  
		{  
			"attribute":"stress",
			"change":"3"
		 }
	  ],
	  "dialogue":[  
		 {  
			"text":"You try to get some work done."
		 },
		 {  
			"text":"One of your coworkers is loudly chatting on the phone."
		 },
		 {  
			"text":"It drives you nuts."
		 }
	  ],
	  "requirements":[  
		  {  
			  "attribute":"stress",
			  "value":10,
			  "operator":">="
		   }
	  ],
	  "image":"bg_work,expr_angry"
   },

   {  
	"name":"Work",
	"group":"work",
	"subgroup":"work",
	"unique":true,
	"effects":[  
	  {  
		  "attribute":"stress",
		  "change":"3"
	   }
	],
	"dialogue":[  
	   {  
		  "text":"You chug another cup of coffee and knuckle down."
	   },
	   {  
		  "text":"You\'re too stressed to get much done."
	   },
	   {  
		  "text":"This just stresses you out more. It\'s a vicious cycle."
	   }
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":">="
		 }
	],
	"image":"bg_work,expr_angry"
 },
 {  
	"name":"Work",
	"group":"work",
	"subgroup":"work",
	"unique":true,
	"effects":[  
	  {  
		  "attribute":"stress",
		  "change":"2"
	   }
	],
	"dialogue":[  
	   {  
		  "text":"You organize your projects and try to make headway."
	   },
	   {  
		  "text":"You get a little done, but stress slows you down."
	   }
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":">="
		 },
		 {  
			"attribute":"intelligence",
			"value":1,
			"operator":">"
		 }
	],
	"image":"bg_work,expr_angry"
 },
	 {  
		"name":"Work - smart",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
			
		],
		"dialogue":[  
		   {  
			  "text":"You breeze thought a small project days before the deadline"
		   },
		   {  
			  "text":"This should keep the boss off your back for a bit!"
		   }
		],
		"requirements":[  
			{  
				"attribute":"intelligence",
				"value":3,
				"operator":">"
			 },
			 {  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 }
		],
		"image":"bg_work,expr_relax"
	 },
	 {  
		"name":"Work - smart",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
			{  
				"attribute":"stress",
				"change":"1"
			 }
		],
		"dialogue":[  
		   {  
			  "text":"One of your coworkers asks you for help on a tough problem."
		   },
		   {  
			  "text":"You both manage to sort it out after some head scratching."
		   }
		],
		"requirements":[  
			{  
				"attribute":"intelligence",
				"value":0,
				"operator":">"
			 },
			 {  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 }
		],
		"image":"bg_work,expr_normal"
	 },
	 {  
		"name":"Work - smart",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
			{  
				"attribute":"stress",
				"change":"1"
			 }
		],
		"dialogue":[  
		   {  
			  "text":"You\'re not sure how to solve this problem."
		   },
		   {  
			  "text":"Wait, you\'ve seen this before -- Quaternions!"
		   },
		   {  
			  "text":"..."
		   },
		   {  
			  "text":"Ugh."
		   }
		],
		"requirements":[  
			{  
				"attribute":"intelligence",
				"value":1,
				"operator":">"
			 }
		],
		"image":"bg_work,expr_normal"
	 },
	 {  
		"name":"Work - smart",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
			{  
				"attribute":"stress",
				"change":"1"
			 }
		],
		"dialogue":[  
		   {  
			  "text":"One of your coworkers from another deparment asks for help."
		   },
		   {  
			  "text":"You both manage to breeze through the work together without affecting deadlines."
		   }
		],
		"requirements":[  
			{  
				"attribute":"intelligence",
				"value":1,
				"operator":">"
			 },
			 {  
				"attribute":"stress",
				"value":10,
				"operator":"<"
			 }
		],
		"image":"bg_work,expr_normal"
	 },
	 {  
		"name":"Work - lazy",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
			{  
				"attribute":"stress",
				"change":"-1"
			 },
			 {  
				"attribute":"laziness",
				"change":"1"
			 }
		],
		"dialogue":[  
		   {  
			  "text":"You don\'t really feel like working."
		   },
		   {  
			  "text":"You just spend your time fiddling with things on your desk."
		   }
		],
		"requirements":[  
			 {  
				"attribute":"laziness",
				"value":4,
				"operator":">"
			 }
		],
		"image":"bg_work,expr_relaxed"
	 },
	   {  
		"name":"Work",
		"group":"work",
		"subgroup":"work",
		"unique":true,
		"effects":[  
			{  
				"attribute":"stress",
				"change":"2"
			 }
		],
		"dialogue":[  
		   {  
			  "text":"You knuckle down for an upcoming deadline."
		   },
		   {  
			  "text":"You panic and don\'t get much done"
		   }
		],
		"requirements":[  
		  {  
			  "attribute":"stress",
			  "value":10,
			  "operator":">="
		   }
		],
		"image":"bg_work,expr_worried"
	 },
	 {  
		"name":"Work - nap",
		"group":"work",
		"subgroup":"nap",
		"unique":true,
		"effects":[  
		  {  
			  "attribute":"stress",
			  "change":"-2"
		   },
		   {  
			"attribute":"laziness",
			"change":"1"
		 }
		],
		"dialogue":[  
		   {  
			  "text":"You sneak a quick nap."
		   },
		   {  
			  "text":"The only evidence of your crime is a keyboard-shaped imprint on your face."
		   }
		],
		"requirements":[  
		  {  
			  "attribute":"stress",
			  "value":10,
			  "operator":"<"
		   }
		],
		"image":"bg_work,expr_sigh"
	 },
	 {  
		"name":"Work - nap",
		"group":"work",
		"subgroup":"nap",
		"unique":true,
		"effects":[  
		  {  
			  "attribute":"stress",
			  "change":"-1"
		   },
		   {  
			"attribute":"laziness",
			"change":"1"
		 }
		],
		"dialogue":[  
		   {  
			  "text":"You sneak a quick nap."
		   },
		   {  
			  "text":"Mmm... Hamburger clouds."
		   }
		],
		"requirements":[  
		  {  
			  "attribute":"stress",
			  "value":10,
			  "operator":"<"
		   }
		],
		"image":"bg_work,expr_sigh"
	 },
	 {  
		"name":"Work - nap",
		"group":"work",
		"subgroup":"nap",
		"unique":true,
		"effects":[  
		  {  
			  "attribute":"stress",
			  "change":"1"
		   },
		   {  
			"attribute":"laziness",
			"change":"1"
		 }
		],
		"dialogue":[  
		   {  
			  "text":"You try to sneak a quick nap."
		   },
		   {  
			  "text":"You\'re too stressed out to doze off, and just end up wasting time."
		   }
		],
		"requirements":[  
		  {  
			  "attribute":"stress",
			  "value":10,
			  "operator":">="
		   }
		],
		"image":"bg_work,expr_worried"
	 },
	   {  
		  "name":"Make Bento",
		  "group":"morning",
		  "subgroup":"cook",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"cooking",
				"change":"1"
			 },
			 {  
				"attribute":"bento",
				"change":"1"
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You make a bento."
			 },
			 {  
				"text":"Onigiri. Again."
			 }
		  ],
		  "requirements":[  
 
		  ],
		  "image":"bg_home"
	   },
	   {  
		  "name":"Make Bento",
		  "group":"morning",
		  "subgroup":"cook",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"cooking",
				"change":1
			 },
			 {  
				"attribute":"bento",
				"change":1
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You make a bento"
			 },
			 {  
				"text":"The eggs are a little burnt."
			 }
		  ],
		  "requirements":[  
			 {  
				"attribute":"cooking",
				"value":0,
				"operator":">"
			 }
		  ],
		  "image":"bg_home"
	   },
	   {  
		  "name":"Make Bento",
		  "group":"morning",
		  "subgroup":"cook",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"cooking",
				"change":1
			 },
			 {  
				"attribute":"bento",
				"change":2
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You make a bento"
			 },
			 {  
				"text":"The sausages look like little octopi!"
			 }
		  ],
		  "requirements":[  
			 {  
				"attribute":"cooking",
				"value":5,
				"operator":">"
			 },
			 {  
				"attribute":"bento",
				"value":0,
				"operator":"="
			 }
		  ],
		  "image":"bg_home"
	   },
	   {  
		  "name":"Read News",
		  "group":"morning",
		  "subgroup":"relax",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"stress",
				"change":"-2"
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You read the morning paper"
			 },
			 {  
				"text":"Looks like Carp isn\'t going to make it this year..."
			 }
		  ],
		  "requirements":[  
 
		  ],
		  "image":"bg_home"
	   },
	   {  
		"name":"watch TV",
		"group":"morning",
		"subgroup":"relax",
		"unique":false,
		"effects":[  
		   {  
			  "attribute":"stress",
			  "change":"-2"
		   }
		],
		"dialogue":[  
		   {  
			  "text":"You check the morning news"
		   },
		   {  
			  "text":"They\'re airing a segment about munchkin kittens."
		   }
		],
		"requirements":[  

		],
		"image":"bg_home"
	 },
	   {  
		  "name":"Train - Normal",
		  "group":"commute",
		  "subgroup":"commute",
		  "unique":false,
		  "effects":[  
 
		  ],
		  "dialogue":[  
			 {  
				"text":"You quietly listen to the rythmic sound of the train."
			 }
		  ],
		  "requirements":[  
 
		  ],
		  "image":"bg_train,expr_normal"
	   },
	   {  
		"name":"Train - Normal2",
		"group":"commute",
		"subgroup":"commute",
		"unique":false,
		"effects":[  

		],
		"dialogue":[  
		   {  
			  "text":"You find a nice quiet spot in the train and do some light reading."
		   },
		   {  
			"text":"Lupin gets away again!"
		 }
		],
		"requirements":[  

		],
		"image":"bg_train,expr_normal"
	 },
	 {  
		"name":"Train - Normal3",
		"group":"commute",
		"subgroup":"commute",
		"unique":false,
		"effects":[  

		],
		"dialogue":[  
		   {  
			  "text":"Your train arrives."
		   },
		   {  
			"text":"Wait."
		 },
		 {  
		  "text":"Why is everyone dressed up as Love L*ve characters?"
	   }
		],
		"requirements":[  

		],
		"image":"bg_train,expr_wat"
	 },
	 {  
	  "name":"Train - Normal2",
	  "group":"commute",
	  "subgroup":"commute",
	  "unique":false,
	  "effects":[  

	  ],
	  "dialogue":[  
		 {  
			"text":"You find a nice quiet spot in the train and do some light reading."
		 },
		 {  
		  "text":"Lupin gets away again!"
	   }
	  ],
	  "requirements":[  

	  ],
	  "image":"bg_train,expr_normal"
   },
	   {  
		  "name":"Train - Groper",
		  "group":"commute",
		  "subgroup":"commute",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"stress",
				"change":1
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You quietly listen to the rythmic sound of the train"
			 },
			 {  
				"text":"...!! Someone touched your butt!"
			 },
			 {  
				"text":"You turn around, but he\'s already gone"
			 }
		  ],
		  "requirements":[  
 
		  ],
		  "image":"bg_train,expr_worried"
	   },
	   {  
		  "name":"No Lunch",
		  "group":"lunch",
		  "subgroup":"lunch",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"money",
				"change":-1
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You grab a cheap bento at the corner store"
			 }
		  ],
		  "requirements":[  
			 {  
				"attribute":"bento",
				"value":0,
				"operator":"="
			 }
		  ],
		  "image":"bg_bento"
	   },
	   {  
		"name":"buy fancy Lunch",
		"group":"lunch",
		"subgroup":"lunchfancy",
		"unique":false,
		"effects":[  
		   {  
			  "attribute":"money",
			  "change":-3
		   },
		   {  
			"attribute":"stress",
			"change":-3
		 },
		 {  
			"attribute":"bento",
			"value":0,
			"operator":"="
		 }
		],
		"dialogue":[  
		   {  
			  "text":"You grab lunch at a upscale cafe."
		   },
		   {  
			"text":"You love the soothing atmosphere and good food."
		 }
		],
		"requirements":[  
		   {  
			  "attribute":"bento",
			  "value":0,
			  "operator":"="
		   },
		   {  
			"attribute":"money",
			"value":1,
			"operator":">"
		 }
		],
		"image":"bg_meal"
	 },
	   {  
		  "name":"Poor lunch",
		  "group":"lunch",
		  "subgroup":"lunch",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"bento",
				"change":-1
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You eat your homemade bento."
			 },
			 {  
				"text":"It\'s a bit salty..."
			 }
		  ],
		  "requirements":[  
			 {  
				"attribute":"bento",
				"value":1,
				"operator":"="
			 }
		  ],
		  "image":"bg_onigiri"
	   },
	   {  
		  "name":"ok lunch",
		  "group":"lunch",
		  "subgroup":"lunch",
		  "unique":false,
		  "effects":[  
			 {  
				"attribute":"bento",
				"change":-2
			 },
			 {  
				"attribute":"stress",
				"change":-1
			 }
		  ],
		  "dialogue":[  
			 {  
				"text":"You eat your homemade bento."
			 },
			 {  
				"text":"You take your time and enjoy the flavor"
			 }
		  ],
		  "requirements":[  
			 {  
				"attribute":"bento",
				"value":2,
				"operator":"="
			 }
		  ],
		  "image":"bg_bento"
	   },
	   
	   {  
		  "name":"Work, issue",
		  "group":"work",
		  "subgroup":"work",
		  "image":"bg_work,expr_cry",
		  "dialogue":[  
			 {  
				"text":"The section chief is yelling at you for a mistake"
			 },
			 {  
				"text":"It\'s not even your fault"
			 }
		  ],
		  "effects":[  
			 {  
				"attribute":"stress",
				"change":"1"
			 }
		  ],
		  "requirements":[  
 
		  ]
	   },
	   {  
		"name":"Wake up",
		"group":"wake",
		"subgroup":"wake",
		"image":"bg_home",
		"dialogue":[  
		   {  
			  "text":"Time to get up."
		   },
		   {  
			  "text":"You wash away your grogginess in the shower."
		   }
		],
		"effects":[  
		   {  
			  "attribute":"money",
			  "change":"1"
		   }
		  
		],
		"requirements":[  
			{  
				"attribute":"stress",
				"value":5,
				"operator":"<"
			 }
		]
	 },
	 {  
	  "name":"Wake up",
	  "group":"wake",
	  "subgroup":"wake",
	  "image":"bg_home",
	  "dialogue":[  
		 {  
			"text":"It\'s morning already."
		 },
		 {  
			"text":"You have trouble deciding between white or stripes."
		 }
	  ],
	  "effects":[  
		 {  
			"attribute":"money",
			"change":"1"
		 }
		
	  ],
	  "requirements":[  
		  {  
			  "attribute":"stress",
			  "value":5,
			  "operator":"<"
		   }
	  ]
   },
   {  
	"name":"Wake up - late",
	"group":"wake",
	"subgroup":"wake",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"Your alarm goes off."
	   },
	   {  
		  "text":"Snooze!"
	   },
	   {  
		  "text":"..."
	   },
	   {  
		  "text":"..."
	   },
	   {  
		  "text":"Ack! If you don\'t hurry you\'re going to be late!"
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"1"
	   },
	   {  
		"attribute":"stress",
		"change":"2"
	 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":5,
			"operator":"<"
		 }
	]
 },   {  
	"name":"Wake up - stressed 1",
	"group":"wake",
	"subgroup":"wake",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"It\'s morning already"
	   },
	   {  
		  "text":"You feel a bit stressed."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"1"
	   }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":5,
			"operator":">="
		 }
	]
 },   {  
	"name":"Wake up - stressed 1",
	"group":"wake",
	"subgroup":"wake",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"W-Wait. It\'s morning?! Already?!"
	   },
	   {  
		  "text":"You feel a bit cheated. Maybe the stress is getting to you."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"1"
	   }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":5,
			"operator":">="
		 }
	]
 },   {  
	"name":"Wake up - stressed 2",
	"group":"wake",
	"subgroup":"wake",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"Unfortunately, yelling at your alarm does not turn it off."
	   },
	   {  
		  "text":"You dread going to work."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"1"
	   }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":">="
		 }
	]
 },   {  
	"name":"Wake up - stressed 2",
	"group":"wake",
	"subgroup":"wake",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You top the morning with obscenities directed at your alarm clock."
	   },
	   {  
		  "text":"You\'re really stressed out."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"1"
	   }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":">="
		 }
	]
 },   {  
	"name":"socialize - booze",
	"group":"socialize",
	"subgroup":"coworkers",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You head out to a bar with your coworkers."
	   },
	   {  
		  "text":"You down a can of Kiririn with a plate of roasted green peas."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"-1"
	   },
	   {  
		"attribute":"stress",
		"change":"-2"
	 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":"<"
		 },
		 {  
			"attribute":"money",
			"value":1,
			"operator":">="
		 }

	]
 },   {  
	"name":"socialize - bar stress",
	"group":"socialize",
	"subgroup":"coworkers",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You head to the bar with your coworkers."
	   },
	   {  
		  "text":"You\'re just not in the mood, and head home early."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"-1"
	   },
	   {  
		"attribute":"stress",
		"change":"-1"
	 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":">="
		 },
		 {  
			"attribute":"money",
			"value":1,
			"operator":">="
		 }

	]
 },   {  
	"name":"socialize - karaoke",
	"group":"socialize",
	"subgroup":"coworkers",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You head out to a local karaoke bar."
	   },
	   {  
		  "text":"You belt out the lyrics to Hanamizuki like a pro."
	   }
	],
	"effects":[  
	   {  
		  "attribute":"money",
		  "change":"-1"
	   },
	   {  
		"attribute":"stress",
		"change":"-2"
	 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":"<"
		 },
		 {  
			"attribute":"money",
			"value":1,
			"operator":">="
		 }

	]
 },   {  
	"name":"socialize",
	"group":"socialize",
	"subgroup":"alone",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You head to a nice quiet family restaurant alone."
	   },
	   {  
		  "text":"One of the regulars brought her little dog again."
	   },
	   {  
		  "text":"You pet it vigorously."
	   }
	],
	"effects":[  
	   {  
		"attribute":"stress",
		"change":"-1"
	 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":"<"
		 }

	]
 },   {  
	"name":"socialize",
	"group":"socialize",
	"subgroup":"alone",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You grab a book and head to a quiet restaurant."
	   },
	   {  
		  "text":"Oh Zenigata, better luck next time!"
	   }
	],
	"effects":[  
	   {  
		"attribute":"stress",
		"change":"-2"
	 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":"<"
		 }

	]
 },   {  
	"name":"socialize",
	"group":"socialize",
	"subgroup":"alone",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		"text":"You grab a book and head to a local restaurant."
	   },
	   {  
		  "text":"There\'s some kind of event going on, it\'s too noisy."
	   }
	],
	"effects":[  

	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":10,
			"operator":"<"
		 }

	]
 },   {  
	"name":"socialize",
	"group":"socialize",
	"subgroup":"alone",
	"image":"bg_bar",
	"dialogue":[  
		{  
			"text":"You grab a book and head to a local restaurant."
		   },
	   {  
		  "text":"It\'s a soothing break from your troubles."
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-2"
		 }
	  
	],
	"requirements":[  
		{  
			"attribute":"stress",
			"value":5,
			"operator":">"
		 }

	]
 },   {  
	"name":"home - chores",
	"group":"home",
	"subgroup":"chores",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You do your laundry."
	   },
	   {  
		  "text":"\"Hand wash only\". Damn."
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"-2"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - chores",
	"group":"home",
	"subgroup":"chores",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"Time to air out the futon."
	   },
	   {  
		  "text":"You hope it doesn\'t rain."
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"-2"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - chores",
	"group":"home",
	"subgroup":"chores",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You do a bit of shopping for daily necessities."
	   },
	   {  
		  "text":"2 for 1 toilet paper!"
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"-2"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - relax",
	"group":"home",
	"subgroup":"relax",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You loaf around the house with no particular goal in mind."
	   },
	   {  
		  "text":"Hmm, onion rings are vegetable donuts."
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-1"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - relax",
	"group":"home",
	"subgroup":"relax",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You persue the nightly dramas."
	   },
	   {  
		  "text":"Wait, Taku\'s sister sister is actually his mother? ...How?"
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-1"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - relax",
	"group":"home",
	"subgroup":"relax",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You take a monent to read that new manga you bought."
	   },
	   {  
		  "text":"One Kick Man is right up your alley."
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-1"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - relax",
	"group":"home",
	"subgroup":"relax",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You unload after a rough day by doing nothing."
	   },
	   {  
		  "text":"It feels great."
	   },
	   {  
		  "text":"...Wait. If a tomato is a fruit, is ketchup a jam?"
	   },
	   {  
		  "text":"I have to google this."
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-1"
		 }
	],
	"requirements":[  
	]
 },   {  
	"name":"home - sleep",
	"group":"sleep",
	"subgroup":"sleep",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You shake off your clothes and crawl into the futon."
	   },
	   {  
		  "text":"...so comfy."
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"1"
		 }
	],
	"requirements":[
		{  
			"attribute":"chores",
			"value":4,
			"operator":"<"
		 }  
	]
 },   {  
	"name":"home - sleep",
	"group":"sleep",
	"subgroup":"sleep",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You slip into your futon and go to sleep."
	   },
	   {  
		  "text":"... it kinda smells."
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"1"
		 }
	],
	"requirements":[
		{  
			"attribute":"chores",
			"value":4,
			"operator":">="
		 }  
	]
 },  {  
	"name":"home - chores",
	"group":"home",
	"subgroup":"chores",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You figure now\'s as good a time as any to get some chores done."
	   },
	   {  
		  "text":"The bathroom receives a proper scrubbing."
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"-1"
		 }
	],
	"requirements":[
	]
 }, {  
	"name":"home - sleep",
	"group":"sleep",
	"subgroup":"sleep",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You hesitantly slide into the futon."
	   },
	   {  
		  "text":"You really need to air this thing out."
	   }
	],
	"effects":[  
		{  
			"attribute":"chores",
			"change":"1"
		 }
	],
	"requirements":[
		{  
			"attribute":"chores",
			"value":6,
			"operator":">="
		 }  
	]
 },   {  
	"name":"free - friends",
	"group":"free",
	"subgroup":"friends",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You make plans and hang out with some friends."
	   },
	   {  
		  "text":"Emi makes the best oolong tea. You hope to absorb her skills via osmosis some day."
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-1"
		 }
	],
	"requirements":[

	]
 },   {  
	"name":"free - friends",
	"group":"free",
	"subgroup":"friends",
	"image":"bg_bar",
	"dialogue":[  
	   {  
		  "text":"You meet up with a friend at the park."
	   },
	   {  
		  "text":"She has a dog. It plays fetch. You know how this goes."
	   }
	],
	"effects":[  
		{  
			"attribute":"stress",
			"change":"-1"
		 }
	],
	"requirements":[
	]
 },      {  
	"name":"free - study",
	"group":"free",
	"subgroup":"study",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You spend some time studying."
	   },
	   {  
		  "text":"Wait, quaternions? I never signed up for this."
	   }
	],
	"effects":[  
		{  
			"attribute":"intelligence",
			"change":"1"
		 }
	],
	"requirements":[
	]
 },      {  
	"name":"free - study",
	"group":"free",
	"subgroup":"study",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You brush up on your academics a bit"
	   },
	   {  
		  "text":"Oh, so it\'s \'handkerchief\', with a d. Interesting!"
	   }
	],
	"effects":[  
		{  
			"attribute":"intelligence",
			"change":"1"
		 }
	],
	"requirements":[
	]
 },      {  
	"name":"free - study",
	"group":"free",
	"subgroup":"study",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You leaf through a biochemistry book."
	   },
	   {  
		  "text":"You\'re not sure if you\'re ever going to need to know this."
	   },
	   {  
		  "text":"But at least you can draw all three forms of glucose now!"
	   }
	],
	"effects":[  
		{  
			"attribute":"intelligence",
			"change":"1"
		 }
	],
	"requirements":[
	]
 },      {  
	"name":"free - study",
	"group":"free",
	"subgroup":"study",
	"image":"bg_home",
	"dialogue":[  
	   {  
		  "text":"You crack open a book on actual rocket science."
	   },
	   {  
		  "text":"...It\'s not as complicated as you had hoped."
	   }
	],
	"effects":[  
		{  
			"attribute":"intelligence",
			"change":"1"
		 }
	],
	"requirements":[
	]
 }
	],
	"days":[  
	   {  
		  "name":"Monday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Meeting",
				"group":"meeting"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Social",
				"group":"socialize"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Home",
				"group":"home"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   },
	   {  
		  "name":"Tuesday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Meeting",
				"group":"meeting"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Social",
				"group":"socialize"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Home",
				"group":"home"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   },
	   {  
		  "name":"Wednesday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Meeting",
				"group":"meeting"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Social",
				"group":"socialize"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Home",
				"group":"home"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   },
	   {  
		  "name":"Thursday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Meeting",
				"group":"meeting"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Social",
				"group":"socialize"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Home",
				"group":"home"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   },
	   {  
		  "name":"Friday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Meeting",
				"group":"meeting"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Work",
				"group":"work"
			 },
			 {  
				"name":"Social",
				"group":"socialize"
			 },
			 {  
				"name":"Commute",
				"group":"commute"
			 },
			 {  
				"name":"Home",
				"group":"home"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   },
	   {  
		  "name":"Saturday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Free",
				"group":"home"
			 },
			 {  
				"name":"Free",
				"group":"home"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Free",
				"group":"free"
			 },
			 {  
				"name":"Free",
				"group":"free"
			 },
			 {  
				"name":"Free",
				"group":"free"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   },
	   {  
		  "name":"Sunday",
		  "events":[  
			{  
				"name":"Wake up",
				"group":"wake"
			 },
			 {  
				"name":"Morning",
				"group":"morning"
			 },
			 {  
				"name":"Free",
				"group":"home"
			 },
			 {  
				"name":"Free",
				"group":"home"
			 },
			 {  
				"name":"Lunch",
				"group":"lunch"
			 },
			 {  
				"name":"Free",
				"group":"free"
			 },
			 {  
				"name":"Free",
				"group":"free"
			 },
			 {  
				"name":"Free",
				"group":"free"
			 },
			 {  
				"name":"Sleep",
				"group":"sleep"
			 }
		  ]
	   }
	],
	"localizedStats":[  
	   {  
		  "id":"cooking",
		  "name":"Cooking Skill",
		  "positive":true
	   },
	   {  
		  "id":"stress",
		  "name":"Stress"
	   },
	   {  
		  "id":"morning.cook",
		  "name":"Cook",
		  "positive":null
	   },
	   {  
		"id":"chores",
		"name":"Chores",
		"positive":false
	 },
	 {  
		"id":"intelligence",
		"name":"Intelligence",
		"positive":true
	 },
	   {  
		  "id":"morning.relax",
		  "name":"Relax",
		  "positive":null
	   },
	   {  
		"id":"work.work",
		"name":"Work",
		"positive":null
	 },
	 {  
	  "id":"work.nap",
	  "name":"Nap",
	  "positive":null
   },
   {  
	"id":"meeting.meeting",
	"name":"Meeting",
	"positive":null
 },
 {  
  "id":"meeting.skip",
  "name":"Skip",
  "positive":null
},
{  
 "id":"home.chores",
 "name":"Chores",
 "positive":null
},
{  
 "id":"home.relax",
 "name":"Relax",
 "positive":null
},
{  
 "id":"free.study",
 "name":"Study",
 "positive":null
},
{  
 "id":"free.friends",
 "name":"Friends",
 "positive":null
},
{  
 "id":"lunch.lunch",
 "name":"Cheap",
 "positive":null
},
{  
 "id":"lunch.lunchfancy",
 "name":"Expensive",
 "positive":null
},
{  
 "id":"socialize.coworkers",
 "name":"Go out",
 "positive":null
},
{  
 "id":"socialize.alone",
 "name":"Alone",
 "positive":null
}

	]
 }
	';
}